import type { UIStringsOverride } from "../i18n-ui.ts";

/** Chinese — Traditional (zh-TW) UI strings. */
export const zhTW: UIStringsOverride = {
  actions: {
    addToCursor: "新增至 Cursor",
    addToVscode: "新增至 VS Code",
    askAI: "向 AI 詢問此頁面",
    connectMcp: "連線至 MCP",
    copied: "已複製！",
    copyClaudeCode: "複製 Claude Code 指令",
    copyCode: "複製程式碼",
    copyCodex: "複製 Codex 指令",
    copyMarkdown: "複製為 Markdown",
    copyServerUrl: "複製伺服器 URL",
    edit: "在 GitHub 上編輯",
    export: "匯出",
    exportEpub: "匯出為 EPUB",
    exportPdf: "匯出為 PDF",
    generating: "產生中…",
    openIn: "在 {name} 中開啟",
    openInChat: "在聊天中開啟",
    scrollToTop: "回到頂部",
  },
  ask: {
    ai: "AI",
    clear: "清除對話",
    close: "關閉",
    copy: "複製對話",
    empty: "針對文件提出問題。",
    error: "抱歉，發生了一些問題。",
    label: "提出問題",
    placeholder: "提出問題…",
    send: "傳送",
    tip: "提示：可透過以下快捷鍵開啟和關閉聊天",
    title: "向 AI 提問",
    you: "你",
  },
  banner: { dismiss: "關閉公告" },
  changelog: {
    description: "產品更新與版本說明。",
    showReleases: "顯示 {version} 的發布",
    title: "更新日誌",
  },
  content: {
    diagramError: "無法顯示此圖表。",
  },
  feedback: {
    no: "沒有幫助",
    question: "這個頁面有幫助嗎？",
    thanks: "感謝你的意見回饋！",
    yes: "有幫助",
  },
  languageSwitcher: { label: "語言", untranslated: "未翻譯" },
  nav: {
    back: "返回",
    breadcrumb: "麵包屑導覽",
    closeNavigation: "關閉導覽",
    deprecated: "已棄用",
    featured: "精選",
    githubRepository: "GitHub 儲存庫",
    navigation: "導覽",
    primary: "主要",
    sections: "章節",
    toggleNavigation: "切換導覽",
    toggleTheme: "切換色彩主題",
  },
  notFound: {
    description: "我們找不到你要瀏覽的頁面。",
    home: "返回首頁",
    title: "找不到頁面",
  },
  page: {
    lastUpdated: "最後更新於",
    next: "下一頁",
    pagination: "分頁",
    previous: "上一頁",
    skipToContent: "跳至內容",
  },
  search: {
    all: "全部",
    allLanguages: "所有語言",
    askAi: "向 AI 提問",
    askAiHint: "從 AI 即時取得解答",
    button: "搜尋",
    devOnly: "搜尋在正式版組建中可用。",
    error: "發生了一些問題，請再試一次。",
    label: "搜尋文件",
    navigate: "導覽",
    noResults: "找不到結果。",
    open: "開啟",
    placeholder: "搜尋文件…",
    popular: "熱門",
    preview: "預覽",
    results: "結果",
  },
  toc: { title: "本頁內容" },
};
